import { Box, Flex, Title, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";
import React from "react";

type TextContentProps = {
  title?: string | null;
  description?: string | null;
  items?: Array<{
    text?: string;
  }> | null;
};

export const TextContent: FC<TextContentProps> = ({
  title,
  description,
  items,
}) => {
  return (
    <Box p={{ py: 16 }} md={{ p: { py: 0 } }}>
      {title && (
        <Title
          data-testid={`main-banner-v4-title`}
          as="h2"
          size="large"
          fontWeight="mobile.superbold"
          fontSize="headline.mobile.large"
          lineHeight="headline.mobile.large"
          horizontalAlign="center"
          bg="text-accent-grad"
          color="transparent"
          maxWidth={360}
          m={{ mb: 8, mx: "auto" }}
          md={{
            horizontalAlign: "left",
            m: { mb: 32, mx: 0 },
            maxWidth: 714,
            fontSize: "headline.desktop.large",
            lineHeight: "headline.desktop.large",
            fontWeight: "desktop.superbold",
          }}
          className="bg-clip-text"
        >
          {title}
        </Title>
      )}
      {description && (
        <Typography
          data-testid={`main-banner-v4-description`}
          as="p"
          fontSize="body.mobile.large"
          lineHeight="body.mobile.large"
          m={{ mb: 32, mx: "auto" }}
          maxWidth={360}
          md={{
            maxWidth: 610,
            m: { mb: 60, ml: 0 },
            fontSize: "body.desktop.large",
            lineHeight: "body.desktop.large",
          }}
        >
          {description}
        </Typography>
      )}

      {items && items.length > 0 && (
        <Flex
          as="ul"
          flexDirection="column"
          align="stretch"
          listStyle={{ type: "none" }}
          md={{ listStyle: { type: "disc", position: "inside" } }}
        >
          {items?.map((item, index) => (
            <Typography
              data-testid={`main-banner-v4-list-item-${index}`}
              key={index}
              as="li"
              display="list-item"
              horizontalAlign="center"
              fontSize={"body.mobile.large"}
              lineHeight={"body.mobile.large"}
              md={{
                fontSize: "button.desktop.large",
                lineHeight: "body.desktop.large",
                horizontalAlign: "left",
              }}
            >
              {item?.text}
            </Typography>
          ))}
        </Flex>
      )}
    </Box>
  );
};
